import { Inbox } from "lucide-react";

export function EmptyState({ title, body, compact = false }: { title: string; body: string; compact?: boolean }) {
  if (compact) {
    return (
      <div className="compact-empty">
        <span>
          <Inbox />
        </span>
        <div>
          <b>{title}</b>
          <small>{body}</small>
        </div>
      </div>
    );
  }
  return (
    <div className="empty-state">
      <span className="empty-icon">
        <Inbox />
      </span>
      <h2>{title}</h2>
      <span>{body}</span>
    </div>
  );
}
